import { toPersianDigits } from "./numberFormat";

const NOT_FOUND = "مورد انتخاب‌شده پیدا نشد.";

const STATUS_MESSAGES = {
  401: "نشست شما منقضی شده است؛ دوباره وارد شوید.",
  403: "اجازه انجام این کار را ندارید.",
  404: "مورد پیدا نشد.",
  413: "حجم اطلاعات ارسالی بیش از حد مجاز است.",
  500: "خطای سرور رخ داد. لطفاً کمی بعد دوباره تلاش کنید.",
};

// Django REST Framework's default English messages, in Persian.
const DRF_MESSAGES = [
  [/^This field is required\.$/, () => "الزامی است."],
  [/^This field may not be blank\.$/, () => "نباید خالی باشد."],
  [/^This field may not be null\.$/, () => "الزامی است."],
  [/^This list may not be empty\.$/, () => "حداقل یک مورد لازم است."],
  [/^Ensure this field has no more than (\d+) characters\.$/, (n) => `حداکثر ${toPersianDigits(n)} نویسه مجاز است.`],
  [/^Ensure this field has at least (\d+) characters\.$/, (n) => `حداقل ${toPersianDigits(n)} نویسه لازم است.`],
  [/^A valid number is required\.$/, () => "باید یک عدد معتبر باشد."],
  [/^A valid integer is required\.$/, () => "باید یک عدد صحیح باشد."],
  [/^Ensure that there are no more than (\d+) digits in total\.$/, (n) => `حداکثر ${toPersianDigits(n)} رقم مجاز است.`],
  [/^Ensure that there are no more than (\d+) decimal places\.$/, (n) => `حداکثر ${toPersianDigits(n)} رقم اعشار مجاز است.`],
  [/^Ensure that there are no more than (\d+) digits before the decimal point\.$/, (n) => `حداکثر ${toPersianDigits(n)} رقم پیش از ممیز مجاز است.`],
  [/^Ensure this value is greater than or equal to (.+)\.$/, (n) => `باید بزرگ‌تر یا مساوی ${toPersianDigits(n)} باشد.`],
  [/^Ensure this value is less than or equal to (.+)\.$/, (n) => `باید کوچک‌تر یا مساوی ${toPersianDigits(n)} باشد.`],
  [/^Invalid pk ".*" - object does not exist\.$/, () => NOT_FOUND],
  [/^Object with .+=.* does not exist\.$/, () => NOT_FOUND],
  [/^Incorrect type\. Expected pk value, received .+\.$/, () => "مقدار انتخاب‌شده نامعتبر است."],
  [/^Invalid hyperlink - .+$/, () => NOT_FOUND],
  [/^Invalid value\.$/, () => "مقدار نامعتبر است."],
  [/^Date has wrong format\./, () => "قالب تاریخ نادرست است."],
  [/^Datetime has wrong format\./, () => "قالب تاریخ و زمان نادرست است."],
  [/^Must be a valid boolean\.$/, () => "مقدار باید بله یا خیر باشد."],
  [/^Not a valid string\.$/, () => "باید متن باشد."],
  [/^Enter a valid email address\.$/, () => "نشانی ایمیل معتبر نیست."],
  [/^"(.*)" is not a valid choice\.$/, (v) => `«${v}» گزینه معتبری نیست.`],
  [/^Expected a list of items but got type/, () => "قالب داده ارسالی نادرست است."],
  [/^Invalid data\. Expected a dictionary, but got/, () => "قالب داده ارسالی نادرست است."],
  [/^The fields .+ must make a unique set\.$/, () => "این مورد قبلاً ثبت شده است."],
  [/ with this .+ already exists\.$/, () => "این مقدار قبلاً ثبت شده است."],
  [/^Authentication credentials were not provided\.$/, () => "ابتدا وارد حساب کاربری شوید."],
  [/^Given token not valid for any token type$/, () => "نشست شما منقضی شده است؛ دوباره وارد شوید."],
  [/^You do not have permission to perform this action\.$/, () => "اجازه انجام این کار را ندارید."],
  [/^Not found\.$/, () => "مورد پیدا نشد."],
  [/^No .+ matches the given query\.$/, () => "مورد پیدا نشد."],
  [/^Request was throttled\./, () => "تعداد درخواست‌ها زیاد است؛ کمی بعد دوباره تلاش کنید."],
  // axios's own messages (error.message) when there is no API response body
  [/^Network Error$/, () => "ارتباط با سرور برقرار نشد. اتصال اینترنت را بررسی کنید."],
  [/^timeout of \d+ms exceeded$/, () => "پاسخ سرور طول کشید؛ لطفاً دوباره تلاش کنید."],
  [/^Request failed with status code (\d+)$/, (code) => STATUS_MESSAGES[code] || (Number(code) >= 500 ? STATUS_MESSAGES[500] : "درخواست انجام نشد؛ اطلاعات واردشده را بررسی کنید.")],
  [/^(canceled|Request aborted)$/, () => "درخواست لغو شد."],
  [/^Method ".+" not allowed\.$/, () => "این عملیات مجاز نیست."],
  [/^Unsupported media type/, () => "نوع داده ارسالی پشتیبانی نمی‌شود."],
  // File uploads
  [/^No file was submitted\.$/, () => "فایلی ارسال نشده است."],
  [/^No file provided\.?$/, () => "فایلی انتخاب نشده است."],
  [/^The submitted file is empty\.$/, () => "فایل ارسالی خالی است."],
  [/^The submitted data was not a valid file\./, () => "فایل ارسالی معتبر نیست."],
  [/^Upload a valid image\./, () => "یک تصویر معتبر بارگذاری کنید."],
  [/^Ensure this filename has at most (\d+) characters/, (n) => `نام فایل حداکثر ${toPersianDigits(n)} نویسه می‌تواند باشد.`],
  [/^Only PDF, JPEG, or PNG files are allowed\.?$/, () => "فقط فایل PDF، JPEG یا PNG مجاز است."],
  // Sign-in
  [/^(Invalid credentials|Unable to log in with provided credentials\.?)$/, () => "ایمیل یا رمز عبور نادرست است."],
  [/^No active account found with the given credentials$/, () => "ایمیل یا رمز عبور نادرست است."],
  [/^Token is invalid or expired$/, () => "نشست شما منقضی شده است؛ دوباره وارد شوید."],
  [/^Password is required\.?$/, () => "رمز عبور الزامی است."],
  // Messages written in this project's views
  [/^The selected company does not exist\.?$/, () => "شرکت انتخاب‌شده وجود ندارد."],
  [/^Create a company before using business data\.?$/, () => "ابتدا یک شرکت تعریف کنید."],
  [/ is temporarily unavailable\.?$/, () => "این اطلاعات موقتاً در دسترس نیست."],
  [/^Invalid JSON response$/, () => "پاسخ سرویس بیرونی نامعتبر بود."],
  [/^(\w+) not found\.?$/i, (name) => `${RECORD_NAMES[name.toLowerCase()] || "مورد"} پیدا نشد.`],
  [/^\w+ is required\.?$/, () => "اطلاعات الزامی ارسال نشده است."],
  [/already exists\.?$/, () => "این مقدار قبلاً ثبت شده است."],
];

const RECORD_NAMES = {
  invoice: "فاکتور",
  seller: "فروشنده",
  buyer: "خریدار",
  customer: "مشتری",
  template: "قالب",
  file: "فایل",
  representation: "وکالت‌نامه",
  check: "چک",
};

const PERSIAN_LETTERS = /[؀-ۿ]/;

export function translateApiMessage(message) {
  const text = String(message ?? "").trim();
  for (const [pattern, translate] of DRF_MESSAGES) {
    const match = text.match(pattern);
    if (match) return translate(...match.slice(1));
  }
  // Never show an untranslated English message; log it so it can be added above.
  if (/[A-Za-z]{3}/.test(text) && !PERSIAN_LETTERS.test(text)) {
    console.warn("Untranslated API message:", text);
    return "درخواست انجام نشد؛ اطلاعات واردشده را بررسی کنید.";
  }
  return text;
}

const messages = (value) => {
  if (typeof value === "string") return translateApiMessage(value);
  if (Array.isArray(value)) return value.map(messages).filter(Boolean).join(" ");
  if (value && typeof value === "object") return Object.values(value).map(messages).filter(Boolean).join(" ");
  return "";
};

export function getFormErrors(error, fieldNames, fallback = "ذخیره انجام نشد. لطفاً دوباره تلاش کنید.") {
  const data = error?.response?.data;
  const fields = {};
  const general = [];
  if (data && typeof data === "object" && !Array.isArray(data)) {
    Object.entries(data).forEach(([key, value]) => {
      const message = messages(value);
      if (!message) return;
      if (fieldNames.includes(key)) fields[key] = message;
      else general.push(message);
    });
  }
  return { fields, general: general.join(" ") || (Object.keys(fields).length ? "لطفاً موارد مشخص‌شده را اصلاح کنید." : fallback) };
}

function statusMessage(error) {
  if (!error?.response) return "ارتباط با سرور برقرار نشد. اتصال اینترنت را بررسی کنید.";
  const { status } = error.response;
  return STATUS_MESSAGES[status] || (status >= 500 ? STATUS_MESSAGES[500] : "");
}

/**
 * Turns an API validation error into Persian lines such as
 * "کالای ۱ – کد کالا: حداکثر ۹ نویسه مجاز است."
 *
 * labels maps field names to Persian labels. A nested list field (like
 * invoice items) maps to { title, label: (index) => "...", fields: {...} }.
 */
export function getApiErrorLines(error, labels = {}, fallback = "ذخیره انجام نشد. لطفاً دوباره تلاش کنید.") {
  const data = error?.response?.data;
  const lines = [];

  const walk = (value, fieldLabels, prefix) => {
    if (value == null) return;
    if (typeof value === "string") {
      lines.push(`${prefix}${translateApiMessage(value)}`);
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((entry) => walk(entry, fieldLabels, prefix));
      return;
    }
    if (typeof value === "object") {
      Object.entries(value).forEach(([key, entry]) => {
        const label = fieldLabels[key];
        const isRowList = Array.isArray(entry) && entry.some((row) => row && typeof row === "object" && !Array.isArray(row));
        if (label && typeof label === "object" && isRowList) {
          entry.forEach((row, index) => {
            if (row && typeof row === "object") walk(row, label.fields || {}, `${prefix}${label.label(index)} – `);
          });
          return;
        }
        const general = ["non_field_errors", "detail", "error"].includes(key);
        const name = typeof label === "string" ? label : label?.title;
        walk(entry, {}, general ? prefix : `${prefix}${name || key}: `);
      });
    }
  };

  if (data && typeof data === "object") walk(data, labels, "");
  else if (typeof data === "string" && data.length < 300 && !/<html/i.test(data)) lines.push(translateApiMessage(data));

  if (!lines.length) lines.push(statusMessage(error) || fallback);
  return lines;
}
